













































































































































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import Util from "@/lib/util";
import AbpBase from "@/lib/abpbase";
import PageRequest from "@/store/entities/page-request";
import Ajax from '../../../lib/ajax';
//import Echarts from "./Echarts.vue";

class PageThRealTimeDataRequest extends PageRequest {
  FilterText: string;
  cId: Number;
  etype:number = 1;
  mac: string;
  Time: string;
  displayId:number;
  startDate:string;
  endDate:string;
  ftId:Number;
  wId:Number;
  fId:Number;
}
class PageCompanyRequest {
  cId: Number;
  ftId:Number;
  wId:Number;
}
@Component({
  components: {},
})
export default class ThRealTimeDatas extends AbpBase {
  pagerequest: PageThRealTimeDataRequest = new PageThRealTimeDataRequest();
  pagecompanyrequest: PageCompanyRequest = new PageCompanyRequest();
  userName: string;
  cId: Number;
  list1;
  totalcount=0;
  mac:string='';
  wflocation:string='';
  selDateTime:Date=new Date();
  temp:string = '';
  humi = [];
  mac1:string='';
  mac2:string='';
  mac3:string='';
  scId:number;
  yieldly:string='';
  years:string='';
  grade:string='';
  searchInt:number = 0;
  IsPostBack:boolean = false;
  selwarehouselist = [];
  selfloorlist = [];
  spinShow = false;

  get list() {
    return this.$store.state.thdata.list;
  }
  get loading() {
    return this.$store.state.thdata.loading;
  }
  async handleExport(){
    let filename = "包芯温湿度数据";
    this.spinShow = true;
    // let res =  await this.$store.dispatch({
    //   type: "thdata/exportExcelsummary",
    //   data: this.pagerequest,
    // });
    // console.log(res);
    // const blob = new Blob([res.data]); // 把得到的结果用流对象转一下
    //   var a = document.createElement("a"); //创建一个<a></a>标签
    //   a.href = URL.createObjectURL(blob); // 将流文件写入a标签的href属性值
    //   a.download = filename+".xls"; //设置文件名
    //   a.style.display = "none"; // 障眼法藏起来a标签
    //   document.body.appendChild(a); // 将a标签追加到文档对象中
    //   a.click(); // 模拟点击了a标签，会触发a标签的href的读取，浏览器就会自动下载了
    //   a.remove(); // 一次性的，用完就删除a标签
    await Ajax.post(
      "/api/services/app/ThData/ExportExcelsummary",
      this.pagerequest,
      {
        responseType: "blob",
      }
    ).then((res) => {
      this.spinShow = false;
      const blob = new Blob([res.data]); // 把得到的结果用流对象转一下
      var a = document.createElement("a"); //创建一个<a></a>标签
      a.href = URL.createObjectURL(blob); // 将流文件写入a标签的href属性值
      a.download = filename+".xls"; //设置文件名
      a.style.display = "none"; // 障眼法藏起来a标签
      document.body.appendChild(a); // 将a标签追加到文档对象中
      a.click(); // 模拟点击了a标签，会触发a标签的href的读取，浏览器就会自动下载了
      a.remove(); // 一次性的，用完就删除a标签
    });
  }
  selCompany(value: Number) {
    this.pagecompanyrequest.cId = value;
    this.getfactory();
    this.getwarehouse();
    this.getfloor();
    this.getPage();
  }
  //库区
  selfactory(value:Number){
    this.pagecompanyrequest.ftId = value;
    // this.getwarehouse();
    //   this.getfloor();
      if(value != 0){
      this.getselwarehouse();
    }
    else
    {
      this.selwarehouselist = [];
      this.selfloorlist = [];
    }
      this.searchInt = 1;
       this.getPage();
  }
  //库房
  selwarehouse(value:Number){
    this.pagecompanyrequest.wId = value;
      // this.getfloor();
      if(value != 0 && value != undefined){
      this.getselfloor();
    }
    else{
      this.selfloorlist = [];
    }
      this.searchInt = 1;
       this.getPage();
  }
  //楼层
  selfloor(value:Number){
    this.searchInt = 1;
    this.getPage();
  }
  dateChange(e){
    if(e[0].length == 0){
      this.pagerequest.startDate = "0001/1/1 0:00:00";
      this.pagerequest.endDate = "0001/1/1 0:00:00";
    }
    else{
      this.pagerequest.startDate = e[0];
      this.pagerequest.endDate = e[1];
    }
  }
  getsearch(){
    this.searchInt = 1;
    this.getPage();
  }
  pageChange(page: number) {
    this.$store.commit("thdata/setCurrentPage", page);
    this.getPage();
  }
  pagesizeChange(pagesize: number) {
    this.$store.commit("thdata/setPageSize", pagesize);
    this.getPage();
  }
  async getPage() {
    this.pagerequest.etype = 1;
     if(this.searchInt == 1){
       this.$store.state.thdata.currentPage=1;
      this.pagerequest.maxResultCount = this.pageSize;
      this.pagerequest.skipCount = 0;
      this.searchInt = 0;
    }
    else{
      this.pagerequest.maxResultCount = this.pageSize;
      this.pagerequest.skipCount = (this.currentPage - 1) * this.pageSize;
    }
    //filters
    await this.$store.dispatch({
      type: "thdata/getPaged",
      data: this.pagerequest,
    });
  }

 
  get pageSize() {
    return this.$store.state.thdata.pageSize;
  }
  get totalCount() {
    return this.$store.state.thdata.totalCount;
  }
  get currentPage() {
    return this.$store.state.thdata.currentPage;
  }
  getuserName() {
    this.userName = this.$store.state.session.user
      ? this.$store.state.session.user.name
      : "";
    return this.userName;
  }
  get company() {
    return this.$store.state.company.list;
  }
  companylist() {
    return this.$store.state.company.list;
  }
  get warehouse() {
    return this.$store.state.warehouse.list;
  }
  get floor() {
    return this.$store.state.floor.list;
  }
  get factory() {
    return this.$store.state.factory.list;
  }
  factorylist(){
    return this.$store.state.factory.list;
  }
  warehouselist() {
    return this.$store.state.warehouse.list;
  }
  floorlist() {
    return this.$store.state.floor.list;
  }
  get thdata() {
    return this.$store.state.thdata.list;
  }
  get smokecrib() {
    return this.$store.state.smokecrib.list;
  }
  smokecriblist(){
    return this.$store.state.smokecrib.list;
  }

  columns = [
    {
      title: "所属公司",
      key: "cId",
      render: (h, params) => {
        let cId = params.row.cId;
        let clist = this.companylist();
        for (let entry of clist) {
          if (cId == entry.id) {
            cId = entry.cName;
            break;
          }
        }
        if (cId == 0) {
          cId = "";
        }
        return h("span", cId);
      },
    },
     {
      title: "库区",
      key: "ftId",
      render: (h, params) => {
        let Id = params.row.ftId;
        let flist = this.factorylist(); 
        for (let entry of flist) {
          if(Id==entry.id){
            Id=entry.fName;
            break;
          }
        }
        return h("span", Id);
      },
    }, 
    {
      title: "库房",
      key: "wId",
      render: (h, params) => {
        let wId = params.row.wId;
        let wlist = this.warehouselist();
        for (let entry of wlist) {
          //console.log(entry.id); // 1, "string", false
          if (wId == entry.id) {
            wId = entry.wName;
            break;
          }
        }
        return h("span", wId);
      },
    },
    {
      title: "楼层",
      key: "fId",
      width:100,
      render: (h, params) => {
        let fId = params.row.fId;
        let flist = this.floorlist();
        for (let entry of flist) {
          //console.log(entry.id); // 1, "string", false
          if (fId == entry.id) {
            fId = entry.fName;
            break;
          }
        }
        return h("span", fId);
      },
    },
    {
      title: "SN号",
      key: "mac",
    },
     {
      title: "烟叶",
      key: "scId",
      width:200,
      render: (h, params) => {
        let scId = params.row.scId;
        let clist = this.smokecriblist();
        for (let entry of clist) {
          //console.log(entry.id); // 1, "string", false
          if(scId==entry.id){
            scId=entry.title;
            break;
          }
        }
        return h("span", scId);
      },
    },
    {
      title: "垛位号",
      key: "locationName",
      width:120,
    },
    {
      title: "剩余电量",
      key: "electric",
      width:100,
      render: (h, params) => {
        let Electric = params.row.electric;
         let username = this.getuserName();
        if(username !== "admin"){
         if(Electric > 30){
            Electric = "电量充足";
          }
          else if(Electric > 11 && Electric < 31){
             Electric = "电量一般";
          }
          else{
             Electric = "电量不足";
          }
        }
        else{
          Electric= Electric.toString() + "%";
        }
        return h("span",Electric);
      },
    },
    {
      title: "信号强度",
      key: "signale",
      width:100,
      render: (h, params) => {
        return h("span", params.row.signale+'%');
      },
    },
    {
      title: "温度",
      key: "temp",
      width:150,
       render: (h, params) => {
         if(params.row.etype == 1){
           var temp = "一号针：" + params.row.temp1 + "℃\n" + "二号针："+ params.row.temp2 + "℃\n" + "三号针：" + params.row.temp3 + "℃";
         }
         else{
           var temp = params.row.temp1 + "℃";

         }
         
        return h("span",{style:"white-space: pre-wrap"}, temp);
      },
    },
    {
      title: "湿度",
      key: "humi",
      width:150,
       render: (h, params) => {
         if(params.row.etype == 1){
            var humi = "一号针：" + params.row.humi1 + "%\n" + "二号针："+ params.row.humi2 + "%\n" + "三号针：" + params.row.humi3 + "%";
         }
         else{
           var humi = params.row.humi1 + "%";
         }
         
        return h("span",{style:"white-space:pre-wrap"}, humi);
      },
    },
    {
      title: "更新时间",
      key: "addTime",
      width:160,
      render: (h, params) => {
        let addTime ='';
        
        addTime=this.GetDay(params.row.addTime)+ " " +this.GetMinutes(params.row.addTime);
        return h("span", addTime);
      },
    },
  ];

  async getcompany() {
    //filters
    await this.$store.dispatch({
      type: "company/getAll",
    });
  }

  GetDay(time) {
    let date = new Date(time);
    let Str = date.getFullYear() + "-" + (date.getMonth()+1) + "-" + date.getDate();
    return Str;
  }

  GetMinutes(time) {
    let date = new Date(time);
    let Str = this.GetBqMinutes(date.getHours()) + ":" + this.GetBqMinutes(date.getMinutes());
    return Str;
  }
GetBqMinutes(str){
    if(str.toString().length==1){
      return '0'+str;
    }
    return str;
  }
  async getsmokecrib() {
    //烟叶
    //filters
    await this.$store.dispatch({
      type: "smokecrib/getAll",
       data: this.pagecompanyrequest,
    });
  }
  async getwarehouse() {
    //库房
    //filters
    await this.$store.dispatch({
      type: "warehouse/getAll",
      data: this.pagecompanyrequest,
    });
  }
  async getfactory(){
      //库区
    //filters
    await this.$store.dispatch({
      type: "factory/getPaged",
      data: this.pagecompanyrequest,
    });
  }
  async getfloor() {
    //楼层
    //filters
    await this.$store.dispatch({
      type: "floor/getAll",
      data: this.pagecompanyrequest,
    });
    }
        async getselwarehouse(){
    this.selwarehouselist = await this.$store.dispatch({
      type: "warehouse/RegetAll",
      data: this.pagecompanyrequest,
    });
  }
   async getselfloor() {
    //下拉库房加载楼层
    //filters
    this.selfloorlist = await this.$store.dispatch({
      type: "floor/RegetAll",
      data: this.pagecompanyrequest,
    });
  }
  created() {
    this.$store.state.thdata.pageSize=10;
    this.$store.state.thdata.currentPage=1;
    this.$store.state.thdata.totalCount=0;
    this.getuserName();
    this.getwarehouse();
    this.getfloor();
    this.getfactory();
    this.getsmokecrib();
    if (this.userName !== "admin") {
      //不符合权限的，你就没有操作这个列名！！！
      this.columns = this.columns.filter((col) => col.title !== "所属公司");
    } else {
      this.getcompany();
    }

    this.getPage();
  }
}
